<template>
    <div>
        <pleitos
            :pleitosServicos="obterDataServicos()"
            rotaDetalhar="Pleitos_Uai_Detalhar"
            rotaListagem="Pleitos_Uai"
            rotaInserir="Pleitos_Uai_Inserir"
            rotaAtualizar="Pleitos_Uai_Atualizar"
            :temAcessoDetalhar="$temAcessoView('PLEITOS-UAI-00')"
            :permiteInserir="$temAcessoView('PLEITOS-UAI-01')"
            :permiteAtualizar="$temAcessoView('PLEITOS-UAI-01')"
            :permiteExcluir="$temAcessoView('PLEITOS-UAI-02')"
            :permiteAprovarPertinencia="$temAcessoView('PLEITOS-UAI-03')"
            :permiteReprovarPertinencia="$temAcessoView('PLEITOS-UAI-03')"
            :permiteAprovarReprovarConformidadeTecnica="$temAcessoView('PLEITOS-UAI-03')"
        ></pleitos>
        <router-view></router-view>
    </div>
</template>

<script>
import PleitosServicos from './PleitosServicos'
import Pleitos from '../componentes/PleitosLista'

export default {
    components: {
        Pleitos
    },

    methods: {
        obterDataServicos() {
            return PleitosServicos
        }
    },
}
</script>

